<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
    
                <div class="text-center">
                    <br /><br />
                    <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                        <br />
    
                        <CRow class="mt-5">
                            <CButton type="button" class="btn custom-button-profile color-blue mb-5" @click="GoToCourse()"> + Add Courses</CButton>
                            <CCol sm="12">
                                <h1 class="custom-header-title-choose text-black mt-3 p-40 text-center poppin-font text-60px">Featured Training Courses</h1>
                                <h3 class="mt-4 mb-4 text-black text-24px text-center p-40 custom-24px-500">By featuring specific training courses, the platform aims to guide users to explore high-quality content, emphasizing key learning opportunities.</h3>
                                <br />
                                <CInput type="text" />
                                <div class="text-left">
                                    <span class="border-white-radius text-black text-left m-2" v-for="item in courses" v-bind:key="item.Category">
                    
                                            <span class="p-2">{{ item.category}}</span>
                                    </span>
                                </div>
    
                            </CCol>
    
                        </CRow>
                        <CRow class="mt-4">
                            <CCol sm="3" v-for="(item,index) in courses" v-bind:key="item.id">
                                <CCard class="p-2 b-8" style="border:none">
                                    <img v-if="item.filePath != null" :src="getThumbnail(index)" style="max-width: 100%" />
                                    <img v-else src="../assets/img/C1.png" class="custom-bg-advetise" />
                                    <h3 class="custom-16px-600 text-left mt-2">{{ item.topic }}</h3>
                                    <span class="text-left ml-1"><img src="../assets/img/staryellow.png" style="width:20px" />
                                            <img src="../assets/img/staryellow.png" style="width:20px" />
                                            <img src="../assets/img/staryellow.png" style="width:20px" />
                                            <img src="../assets/img/staryellow.png" style="width:20px" />
                                            <img src="../assets/img/staryellow.png" style="width:20px" />
                                            (7)
                                        </span>
                                    <hr />
                                    <p class="custom-12px-400 poppin-font">{{ item.synopsis }}</p>
                                    <CRow>
                                        <CCol sm="6">
                                            <div class="float-left">
                                                <CButton class="custom-btn-light-blues custom-12px-600 blue-color"> <strong>{{ item.category }}</strong></CButton>
                                            </div>
                                        </CCol>
                                        <CCol sm="6">
                                            <p class="custom-price-course float-right">RM {{ formatPrice(item.price) }}</p>
                                        </CCol>
                                    </CRow>
    
                                </CCard>
                            </CCol>
    
    
                        </CRow>
                        <CCol sm="12">
                            <div class="text-center mt-5">
                                <CButton type="button" class="btn custom-button-profile color-blue mb-5">Lihat lagi</CButton>
                            </div>
                        </CCol>
    
                    </CCol>
                </div>
            </CCol>
    
        </CCol>
    </div>
</template>


<script>
import moment from "moment";
Vue.use(require("vue-moment"));

import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/AllHeader.vue";

export default {
    name: "App",
    components: {
        Mainlayout
    },
    created() {
        AOS.init();
    },
    data: () => ({

        courses: [],
    }),
    async mounted() {
        let isAuth = await this.UserAuth();

        if (isAuth) {
            this.Busy = false;
            this.GetInfoUser();

            this.GetListCourse();
        } else {
            this.GoToLogin();
        }
    },
    //async mounted() {},
    methods: {
        GetInfoUser() {
            return this.$API
                .get(this.$LoginUserDetail, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.user = response.data;
                        this.GetAuthorizeProfile(this.user.id);
                        this.GetContinueWatching(this.user.id);
                    }
                });
        },
        GetAuthorizeProfile() {
            this.$API
                .get(this.$PickiddoUserProfile + "?userId=" + this.user.id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.studentProfileAuthorize = response.data;
                        this.photoURL = this.studentProfileAuthorize.filePath;
                    }
                });
        },

        GetListCourse() {
            this.$API.get(this.$GetListVideoJustForYou).then((response) => {
                if (response.status == 200 && response.data != null) {
                    this.courses = response.data;
                    this.getThumbnail(this.courses.filePath);
                }
            });
        },
        getThumbnail(index) {
            return (
                "https://d3us0m7iuwh1d3.cloudfront.net/" + this.courses[index].filePath
            );
        },

        logDuration(index) {
            durationVideos =
                "https://d3us0m7iuwh1d3.cloudfront.net/" +
                this.popular[index].fileVideo;
            //  this.durationVideo = this.$refs.durationVideos.duration;
            console.log("masuk", this.durationVideo);

            var x = this.$refs.durationVideos.duration;
            return x;
        },
        formatPrice(price) {
            // Check if price is a number or can be converted to a number
            if (!isNaN(parseFloat(price)) && isFinite(price)) {
                // Use toFixed(2) to format the number to two decimal places
                return parseFloat(price).toFixed(2);
            } else {
                // Handle cases where price is not a valid number
                return "N/A";
            }
        },
        GoToCourse() {
            this.$router.push("UploadCourse")
        }
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>